var map = {
	"./Pagination.vue": 7674,
	"./VButton.vue": 450,
	"./VButtonDelay.vue": 5498,
	"./VImg.vue": 2867,
	"./VInputCheckbox.vue": 4663,
	"./VInputNumber.vue": 6079,
	"./VInputSelect.vue": 3837,
	"./VInputText.vue": 8559,
	"./VLoader.vue": 1821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;